import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'solar-bo';
import { Subscription } from 'rxjs';


import { BaseComponent } from './base.component';

@Component({
  selector: 'app-edit-base',
  template: ''
})
export class EditBaseComponent extends BaseComponent implements OnInit {

  @Input() showheader: boolean = false;
  @Output() saveEvent = new EventEmitter<any>();
  @Input() uitype: number = 0;//0 estandar 1=modal 2=only UI

  @Input() editablemode: boolean = true;

  public subscriptiontomodelchanges: Subscription;
  
  public constructor() {
    super();
   
  }

  ngOnInit() { }

}